// @ngInject
function printInventoryReportDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'printInventoryReportDialogController as vm',
            templateUrl: 'services/dialogs/printInventoryReportDialog/printInventoryReportDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function printInventoryReportDialogController($uibModalInstance, $window, message, level, $sce) {
    var vm = this;

    //Properties
    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.printLanguage = 'se';
    vm.printFormat = 'pdf';

    //Methods
    vm.closeModal = closeModal;
    vm.setLanguage = setLanguage;
    vm.setPrintFormat = setPrintFormat;

    readSettingsFromLocalStorage();

    function closeModal(isCompleted) {
        var result = {
            result: isCompleted,
            languageCode: vm.printLanguage,
            printFormat: vm.printFormat
        };
        saveSettingsToLocalStorage();
        $uibModalInstance.close(result);
    }

    function setLanguage(language) {
        vm.printLanguage = language;
    }
    function setPrintFormat(format) {
        vm.printFormat = format;
    }

    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printInventoryReportSettings) {
            if (!isJsonString($window.localStorage.getItem('printInventoryReportSettings'))) {
                $window.localStorage.removeItem('printInventoryReportSettings');
            }

            var settingsStr = $window.localStorage.getItem('printInventoryReportSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.printLanguage) { vm.printLanguage = json.printLanguage; }
                if (json.printFormat) { vm.printFormat = json.printFormat; }
            }
        }
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function saveSettingsToLocalStorage() {
        var request = {
            printLanguage: angular.copy(vm.printLanguage),
            printFormat: angular.copy(vm.printFormat)
        };

        $window.localStorage.setItem('printInventoryReportSettings', JSON.stringify(request));
    }
}

angular
    .module('services.dialogs.printInventoryReportDialog', [])
    .service('printInventoryReportDialogService', printInventoryReportDialogService)
    .controller('printInventoryReportDialogController', printInventoryReportDialogController);
